import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCart } from "@/context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Pagina di atterraggio del link di recupero: ricostruisce il carrello dallo
// snapshot (prezzi/disponibilita' ricontrollati lato server) e porta al checkout.
export default function RecoveryLanding() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { addItem, clearCart } = useCart();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/recovery/${token}`);
        const items = (data.items || []).filter((i) => i.available);
        if (items.length === 0) {
          setError("I prodotti del tuo carrello non sono piu' disponibili.");
          return;
        }
        clearCart();
        items.forEach((it) =>
          addItem(
            {
              product_id: it.product_id,
              slug: it.slug,
              name: it.name,
              brand: it.brand,
              grade: it.grade,
              unit_price: it.unit_price,
              image: it.image,
            },
            it.quantity || 1,
            { openCart: false }
          )
        );
        setTimeout(() => navigate(data.checkout_path || "/checkout"), 300);
      } catch (e) {
        setError("Questo link non e' piu' valido o e' scaduto.");
      }
    })();
  }, [token, addItem, clearCart, navigate]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6" data-testid="recovery-landing">
      <div className="text-center">
        {!error ? (
          <>
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-[#C6F24E] border-t-transparent" />
            <p className="text-chalk">Stiamo ricostruendo il tuo carrello...</p>
          </>
        ) : (
          <>
            <p className="mb-4 text-chalk">{error}</p>
            <button
              onClick={() => navigate("/catalogo")}
              className="rounded-full bg-[#C6F24E] px-6 py-3 font-semibold text-[#0A0A0B]"
              data-testid="recovery-browse"
            >
              Vai al catalogo
            </button>
          </>
        )}
      </div>
    </div>
  );
}
